import { SvgIcon } from "@mui/material";
import React from "react";

function Mail(props) {
  return (
    <SvgIcon viewBox="0 0 20 16" {...props}>
      <path
        d="M16.875 0C17.7038 0 18.4987 0.324175 19.0847 0.90121C19.6708 1.47825 20 2.26087 20 3.07692V12.9231C20 13.7391 19.6708 14.5218 19.0847 15.0988C18.4987 15.6758 17.7038 16 16.875 16H3.125C2.2962 16 1.50134 15.6758 0.915291 15.0988C0.32924 14.5218 0 13.7391 0 12.9231V3.07692C0 2.26087 0.32924 1.47825 0.915291 0.90121C1.50134 0.324175 2.2962 0 3.125 0H16.875ZM18.75 4.87508L10.3175 9.76123C10.2378 9.80732 10.1487 9.83542 10.0566 9.8435C9.9645 9.85159 9.87175 9.83947 9.785 9.808L9.6825 9.76123L1.25 4.87754V12.9231C1.25 13.4127 1.44754 13.8823 1.79917 14.2285C2.15081 14.5747 2.62772 14.7692 3.125 14.7692H16.875C17.3723 14.7692 17.8492 14.5747 18.2008 14.2285C18.5525 13.8823 18.75 13.4127 18.75 12.9231V4.87508ZM16.875 1.23077H3.125C2.62772 1.23077 2.15081 1.42527 1.79917 1.77149C1.44754 2.11772 1.25 2.58729 1.25 3.07692V3.44862L10 8.51692L18.75 3.44615V3.07692C18.75 2.58729 18.5525 2.11772 18.2008 1.77149C17.8492 1.42527 17.3723 1.23077 16.875 1.23077Z"
        fill="#5F5C5C"
      />
    </SvgIcon>
  );
}

export default Mail;
